/* Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved. */

export const videoPages = {
    VideosPage: () => import('@/browse/VideosPage'),
    VideoPodcastsPage: () => import('@/browse/VideoPodcastsPage'),
    sharedVideo: () => import('@/video/sharedVideo'),
}
